var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOthers = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 14,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16.471,
  height: 2.471,
  fill: "#fff",
  rx: 1.235
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 16.471,
  height: 2.471,
  y: 5.765,
  fill: "#fff",
  rx: 1.235
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 16.471,
  height: 2.471,
  y: 11.529,
  fill: "#fff",
  rx: 1.235
})));
export default SvgOthers;